import React from "react";

// Logo assets uploaded by the user
export const HEADER_LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_seat-reserve-77/artifacts/75d9rcop_Header%20Logo.png";
export const FOOTER_LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_seat-reserve-77/artifacts/lki4d38k_Footer%20Logo.webp";

// Header/hero brand image logo — the full emblem with vehicles + SHRUTI TOURS AND TRAVELS
export function HeaderLogo({ className = "", size = "md" }) {
  const sizes = {
    xs: "h-12 md:h-14",
    sm: "h-14 md:h-16",
    md: "h-16 md:h-20",
    lg: "h-24 sm:h-32 md:h-40 lg:h-48",
    hero: "h-56 sm:h-72 md:h-80 lg:h-96",
  };
  return (
    <img
      src={HEADER_LOGO_URL}
      alt="Shruti Tours and Travels"
      className={`${sizes[size]} w-auto object-contain ${className}`}
      data-testid="header-logo-img"
    />
  );
}

// Footer brand image logo — the SHRUTI + road + bus emblem
export function FooterLogo({ className = "" }) {
  return (
    <img
      src={FOOTER_LOGO_URL}
      alt="Shruti Tours and Travels"
      className={`h-20 md:h-24 w-auto object-contain ${className}`}
      data-testid="footer-logo-img"
    />
  );
}
